import { useEffect } from 'react';

const WidgetLoader = () => {
    useEffect(() => {
        // This is just a backup - initial state should have handled it
        const searchParams = new URLSearchParams(window.location.search);
        const fromWidget = searchParams.get('from_widget');

        if (fromWidget === 'true') {
            console.log('WidgetLoader: Setting auto-search flag');

            // Set flag for auto-search in RoomSelection
            sessionStorage.setItem('shouldAutoSearch', 'true');
        }
    }, []);

    return null;
};

export default WidgetLoader;
